
import React, { PropsWithChildren } from "react";
import { Button, Modal, ModalBody } from "reactstrap";

interface ModalI {
  showModal: boolean;
  onConfirmation: () => void;
  toggleModal: () => void;
  title: string;
}

const DynamicConfirmationModal: React.FC<PropsWithChildren<ModalI>> = ({
  showModal,
  toggleModal,
  onConfirmation,
  title,
}) => {
  return (
    <Modal className="delete_modal" isOpen={showModal} toggle={toggleModal}>
      <ModalBody>
        <div className="delete_modal_body">
          <h4>{title}</h4>
          <div className="delete_div_btn">
            <Button
              // variant="danger"
              className="btn delete_btn"
              onClick={() => onConfirmation()}
            >
              Ok
            </Button>
            <Button
              // variant="default"
              className="btn delete_btn"
              onClick={toggleModal}
            >
              No
            </Button>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default DynamicConfirmationModal;
